"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.THELOOPS_MESSAGES = exports.THELOOPS_API_ENDPOINTS = void 0;
// TheLoops Integration API Constants
var THELOOPS_API_ENDPOINTS = {
  INSTALL: '/integration/theloops/install',
  UNINSTALL: '/integration/theloops/uninstall',
  GET_WIDGETS: '/integration/theloops/widgets',
  ENABLE_WIDGET: '/integration/theloops/enableWidget',
  ONBOARD_COMMUNITY_DETAILS: '/integration/theloops/details',
  GENERATE_JWE_TOKEN: '/integration/theloops/generateWidgetJWEToken'
};
exports.THELOOPS_API_ENDPOINTS = THELOOPS_API_ENDPOINTS;
var THELOOPS_MESSAGES = {
  INSTALL_SUCCESS: 'All set! TheLoops installed.',
  INSTALL_ERROR: 'Failed to install TheLoops. Please check your credentials.',
  UNINSTALL_SUCCESS: 'TheLoops uninstalled successfully.',
  UNINSTALL_ERROR: 'Failed to uninstall TheLoops. Please try again.',
  SETTINGS_SAVE_SUCCESS: 'Integration settings saved successfully.',
  SETTINGS_SAVE_ERROR: 'Failed to save integration settings. Please try again.',
  WIDGET_ENABLE_ERROR: 'Failed to enable selected widget',
  API_KEY_REQUIRED: 'Please enter an Shared Secret.',
  DOMAIN_REQUIRED: 'Please enter a domain.'
};
exports.THELOOPS_MESSAGES = THELOOPS_MESSAGES;